export default function g(i) {
  return document.getElementById(i);
}
